export default "__VITE_ASSET__CFp70dBk__"